export enum SftpAuthType {
	Password,
	SSH,
}
